module.exports = __webpack_public_path__ + "static/media/paper.8b013d9c.jpg";